import React, { useRef, useEffect, useState } from 'react'
import globalData from 'meinian-package/src/common/globalData'
import FirstTooltip, { FIRST_TOOLTIP_TYPE } from 'meinian-package/src/component/firstTooltip'
import { request } from 'meinian-package/src/utils'
import WorkbenchList from './workbenchList'
import WorkPanel from './workPanel'
import CommonInspiration from './commonInspiration'
import { StyleSwitchingView, OldEdition, VIEW_MODE, STYLE_RULES_KEY, STYLE_TYPE_KEY, STYLE_RULES_VALUE } from '../../components/fixedOperation'
import Header from './header'
import Banner from './banner'
import OfficialInspirationModal from './officialInspirationModal'
import ForceGuidePanel from './forceGuidePanel'
import workbenchForceGuide, { GUIDE_START_KEY } from './forceGuideConfig'
import styles from './index.module.less'

export default () => {
  const listRef = useRef()
  const [columnRulesType, setColumnRulesType] = useState(STYLE_RULES_VALUE)
  const [viewMode, setViewMode] = useState(VIEW_MODE.TEXT)
  const [forceGuideHidden, setForceGuideHidden] = useState(0)
  const [forcePositions, setForcePositions] = useState([])
  const [bannerHidden, setBannerHidden] = useState(1)
  const [bannerOptions, setBannerOptions] = useState([])

  useEffect(() => {
    globalData.get(STYLE_RULES_KEY, setColumnRulesType, STYLE_RULES_VALUE)
    globalData.get(STYLE_TYPE_KEY, setViewMode, VIEW_MODE.TEXT)
  }, [])

  useEffect(() => {
    globalData.get(GUIDE_START_KEY, setForceGuideHidden, 1)
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const result = await request.get('/backend-api/operation/common/position/list-task?positionId=56&limit=5')
    const idsString = await globalData.toGet('mn-workbench-banner')
    const newIdsString = result.map(item => item.id)?.join(',')
    if (newIdsString === idsString) {
      setBannerHidden(0)
    } else {
      setBannerHidden(1)
    }
    setBannerOptions(result)
  }

  workbenchForceGuide.useOn((position) => {
    setForcePositions(position)
  }, bannerHidden)

  return <>
    {
      !!forceGuideHidden && <ForceGuidePanel
        positions={forcePositions}
        onClose={() => {
          setForceGuideHidden(0)
          globalData.set(GUIDE_START_KEY, 0)
        }}
      />
    }
    <OfficialInspirationModal />
    <Header />
    {
      !!bannerHidden && <Banner
        options={bannerOptions}
        onClose={(ids) => {
          setBannerHidden(0)
          globalData.set('mn-workbench-banner', ids)
        }}
      />
    }
    <div className={styles['mn-workbench']}>
      <WorkPanel />
      <CommonInspiration />
      <WorkbenchList ref={listRef} columnRulesType={columnRulesType} viewMode={viewMode} />
      <FirstTooltip
        text="点此切换视图列表"
        placement="left"
        keyValue="mn-workbench-switch-view-1"
        type={FIRST_TOOLTIP_TYPE.LEFT}
      >
        {({ onClose }) => <StyleSwitchingView
          style={{ right: 16, bottom: 176 }}
          columnRulesType={columnRulesType}
          viewMode={viewMode}
          onClick={onClose}
          onColumnRulesType={(val) => {
            setColumnRulesType(val)
            globalData.set(STYLE_RULES_KEY, val)
            listRef.current.onInit(val)
          }}
          onViewMode={(val) => {
            setViewMode(val)
            globalData.set(STYLE_TYPE_KEY, val)
            listRef.current.onInit(val)
          }}
        />}
      </FirstTooltip>
      <OldEdition style={{ right: 16, bottom: 112 }} />
    </div>
  </>
}
